import hicarImage from "../../components/ProgramCatalog/assets/hicar.webp";
import entcImage from "../../components/CoursePage/assets/entc-logo.webp";
import Abarajithan from "../../components/CoursePage/assets/instructor-img/Abarajithan Gnaneswaran.webp";
import kithmin from "../../components/CoursePage/assets/instructor-img/Kithmin.jpg";
import lohan from "../../components/CoursePage/assets/instructor-img/Lohan_Atapattu.jpg";
import subodha from "../../components/CoursePage/assets/instructor-img/Subodha Charles.webp";
import yasiru from "../../components/CoursePage/assets/instructor-img/YasiruAmarasinghe.jpg";
import mewan from "../../components/CoursePage/assets/instructor-img/Mewan_Rathnayak.jpg";
import thishkaya from "../../components/CoursePage/assets/instructor-img/Thishakya_Bandara.jpeg";
import anuki from "../../components/CoursePage/assets/instructor-img/Anuki_Pasqual.jpg";
import agasthi from "../../components/CoursePage/assets/instructor-img/AgasthiManodya .jpg";
import hicarFlyer from "../../components/CoursePage/assets/hicar.jpg";
import { ECourseStatus, ICourse } from "../utils/utils";

export const hicarCourse: ICourse = {
  header: {
    courseImage: hicarImage,
    programCategory: "Workshop",
    difficultyLevel: "Intermediate",
    courseTitle: "Hands-on Introduction to Computer Architecture with RISC-V",
    specialization: "Build Your Own CPU",
    courseDescription:
      "Join our 8-week bootcamp to get comprehensive training on how to design, build, test & implement a RISC-V CPU in SystemVerilog.",
    registerButton: "Registration Closed!",
    registerLink: "",
    secondaryName: "",
  },
  headerSecondSection: {
    starCount: 0,
    reviewCount: 0,
    registrationDeadline: "4 May 2025",
    parameterOne: "Estimated Time:",
    parameterTwo: "8 weeks",
    parameterThree: "New Course",
    collaborationLogos: [
      {
        collaborationLogo: entcImage,
        collaborationLogosName: "ENTC Logo",
      },
    ],
  },
  courseOutline: [
    {
      session: "",
      sessionContent: [
        {
          heading: "Introduction to Computer Architecture",
          description: "",
          subContent: [],
        },
        {
          heading: "Primer on SystemVerilog (Hardware Description Language)",
          description: "",
          subContent: [
            {
              heading: "",
              description: "State Machine design, Testbench",
            },
            {
              heading: "",
              description: "GitHub Actions CI/CD",
            },
            {
              heading: "",
              description: "Using OSIC flow to Synthesize, Place & Route",
            },
          ],
        },
        {
          heading: "Building the state machine CPU",
          description: "",
          subContent: [],
        },
        {
          heading: "Expanding into the CPU structure",
          description: "",
          subContent: [],
        },
        {
          heading:
            "Expanding into the simplest useful RISC-V CPU & executing programs",
          description: "",
          subContent: [],
        },
        {
          heading:
            "Understanding RISC-V Assembly: More interesting and complex programs",
          description: "",
          subContent: [],
        },
        {
          heading: "Performance of CPUs",
          description: "",
          subContent: [],
        },

        {
          heading: "Multi-cycle CPU – discuss hazards and solutions",
          description: "",
          subContent: [],
        },

        {
          heading: "Advanced Topics",
          description: "",
          subContent: [
            {
              heading: "",
              description: "Cycles per instruction (CPI)",
            },
            {
              heading: "",
              description: "Amdhal’s Law",
            },
            {
              heading: "",
              description:
                "Design goals: functional, performance, power, security, cost, reliability",
            },
            {
              heading: "",
              description: "Introducing Memory hierarchy (cache types)",
            },
            {
              heading: "",
              description: "System-on-Chips (SOCs)",
            },
          ],
        },

        {
          heading: "Conclusion, Final presentations and Next steps",
          description: "",
          subContent: [],
        },
      ],
    },
  ],
  faqs: [
    {
      question:
        "I have no prior knowledge of CMOS Analog IC Design and Simulation. Will I be able to do this course?",
      answer:
        "Yes. We teach all the required skills. The only expectation is that you have basic knowledge of mathematical concepts and engineering fundamentals",
    },
    {
      question:
        "Do I need electronic equipment/software licenses to complete this course?",
      answer:
        "Yes. You will need hardware to complete the course. We will facilitate the purchasing process during the course.",
    },
    {
      question:
        "Will I be able to build things at the end of the course, or is it only theory?",
      answer:
        "Of course, you will be able to build things. The course is outcome-oriented, so at the end of the course, you will know how to develop IoT products.",
    },
    {
      question: "Is the course taught online?",
      answer:
        "Yes. The course lectures are all conducted online. We will arrange hands-on sessions at ENTC laboratories as required.",
    },
    {
      question: "Will lecture recordings be made available?",
      answer:
        "Yes. All course materials will be made available through an online learning management system called Moodle. All paid participants will be granted access to the course Moodle page.",
    },
  ],
  experts: [
    {
      image: Abarajithan,
      name: "Mr. Abarajithan Gnaneswaran",
      designation: "PhD Candidate, University of California, San Diego, USA",
    },
    {
      image: kithmin,
      name: "Mr. Kithmin Wickremasinghe",
      designation: "MASc, Electrical and Computer Eng., UBC, Canada",
    },

    {
      image: yasiru,
      name: "Mr. Yasiru Amarasinghe",
      designation: "Embedded Engineer",
    },
    {
      image: mewan,
      name: "Mr. Mewan Rathnayaka",
      designation: "Embedded Engineer",
    },
    {
      image: thishkaya,
      name: "Mr. Thishakya  Bandara",
      designation: "Embedded Engineer",
    },
    {
      image: anuki,
      name: "Ms. Anuki Pasqual",
      designation: "Firmware Engineer",
    },

    {
      image: agasthi,
      name: "Mr. Agasthi Haputhanthri",
      designation: "Embedded Engineer",
    },

    {
      image: lohan,
      name: "Mr. Lohan Atapattu",
      designation: "4th Year Undergraduate",
    },

    {
      image: subodha,
      name: "Dr. Subodha Charles",
      designation: "Senior Lecturer, ENTC, UoM",
    },
  ],
  studentReviews: [
    "On the 1st day, when I saw the registration details, I went through the course curriculum and I joined the course with an expectation. The team fulfilled my expectations 100%.",
    "The course is very interesting and provides a good knowledge in the intended learning area. I would like to see more courses like this in future.",
    "This was a great course. Although the instructors couldn't touch all the aspects, guiding the students on what to follow and refer to is a great thing. Grateful for the organizers and instructors sharing their knowledge. Hope to join the next courses as well.",
    "The personal ML/embedded projects that the instructors shared as case studies were really inspiring. Sharing the ups and downs and what to expect along this path is a real motivator!",
    "Flow of the content was really great. It will really help to beginners who are entering to ML & Edge computing.",
  ],
  facts: [
    {
      fact: "SystemVerilog is not an entirely new RTL language. With its rich set of extensions to the existing Verilog HDL, SystemVerilog is backward compatible with both Verilog 95 and Verilog 2001. Many of these extensions to Verilog make it easier to create accurate, synthesizable models of designs of any size.",
      factBold: "",
      author: "-EETimes-",
    },
    {
      fact: "The global Application Processor Market is expected to reach USD 38 billion by 2024, at a CAGR of 5.5% from 2018 to 2024.",
      factBold: "",
      author: "-MarketWatch-",
    },
  ],
  classSchedule: [
    "11 October 2025 (Concluded)",
    "25 October 2025",
    "26 October 2025",
    "01 November 2025",
    "02 November 2025",
    "08 November 2025",
    "09 November 2025",
    "15 November 2025",
    "16 November 2025",
    "22 November 2025",
    "23 November 2025",
    "29 November 2025",
    "06 December 2025",
    "07 December 2025",
    "13 December 2025",
    "14 December 2025",
    "20 December 2025",
  ],

  showSchedule: true,
  prerequisite:
    "Highly recommended for those who have already taken the “{System}Verilog for ASIC/FPGA Design & Simulation” course offered by Skill Surf.",
  isCourseFlyer: true,
  flyer: {
    description:
      "Learn more about Hands-on Introduction to Computer Architecture with RISC-V short course from the course announcement flyer",
    button: "View Flyer",
    image: hicarFlyer,
  },

  learnMore: {
    description:
      "Learn more about Hands-on Introduction to Computer Architecture with RISC-V",
    button: "Read More",
    articleLink:
      "https://medium.com/@SkillSurfEdu/build-your-own-cpu-system-verilog-for-asic-fpga-design-simulation-afeb3bb25468",
  },
  /*  firstSessionFreeDetails: {
    instruction: {
      isInstructive: false,
      instructiveText:
        "The first session, which was free of charge to everyone, was held on 11 October 2025. The recording of the session is made available below.",
      instructiveTextSecond:
        "Only paid participants can attend from day 2 onwards. So, please complete the payment by ",
      date: "",
      dateSecond: "19 October 2025.",
      buttonText: "View Course Outline",
      buttonTextInfo: "Download",
      viewIntruction: "",
      instructionVideoTopic:
        "Recording of the first sessions held on 11 October 2025",
      instructionVideoUrl: "n7taPNYRY9U",
      videoTwoTopic: "",
      videoTwoUrl: "",
      viewIntructionLink: "",
      buttonLink: "",
      buttonLinkInfo: "", //slides
      moreInformation:
        "For any questions, please email skillsurfedu@gmail.com.",
      slideButtonText: "Download Slides:",
      paymentInstructionButtonText: "here.",
      paymentInstructionButtonLink:
        "https://drive.google.com/file/d/13N30PQdngNBrWbhhUcHg2zwwU9G279zE/view?usp=sharing",
      paymentInstructionText:
        "Payment and other related instructions can be found",
      enrollmentFormLink: "https://forms.gle/9TaErVP3m9aFAxeX7",
    },
  }, */
  courseStatus: ECourseStatus.NEW,
  showTimer: false,
  isDifferentBullet: true,
  isResources: false,
  resourcesYoutubeLink: "https://www.youtube.com/@skillsurfedu",
  resourcesGitHubLink: "https://github.com/SkillSurf/introduction_genAI",
  timerDate: "2024-06-06 00:00",
};
